export const DEFAULT_ERROR = {
	codes: [403, 500, 404],
	message:
		"Something went wrong. Please try again later or contact the support team",
};
